'use strict';

// filter by multiple object properties, example: filterByMultiTokens:['EmployeeFirstName', 'EmployeeLastName']

angular.module('filters.filterByMultiTokens', [])
.filter('filterByMultiTokens', ['$parse', function ($parse) {

    function toArray(object) {
        return angular.isArray(object) ? object :
          Object.keys(object).map(function (key) {
              return object[key];
          });
    }

    return function (collection, properties, search) {

        var comparator;

        search = (angular.isString(search) || angular.isNumber(search)) ?
          String(search).toLowerCase() : undefined;

        collection = (angular.isObject(collection)) ? toArray(collection) : collection;

        if (!angular.isArray(collection) || angular.isUndefined(search)) {
            return collection;
        }

        return collection.filter(function (elm) {

            var toFilter = _.map(properties, function (items) { return elm[items]; }).join(' ');

            var isToFilter = false;
            var searchLength = 0;
            var searchSplit = search.split(' ');

            searchSplit.forEach(function (items) {
                if (_.contains(toFilter.toLowerCase(), items)) {
                    searchLength++;
                    if (searchLength == searchSplit.length) isToFilter = true;
                }
            });

            return isToFilter;
        });
    }
}]);